import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';
import { getAnalytics } from "firebase/analytics";
import { getStorage } from "firebase/storage";
import { getMessaging, getToken, onMessage } from "firebase/messaging";

const firebaseConfig = {
  apiKey: "AIzaSyBAr9DuoDh5iug_idGuAcWBdAuh6DJqsNk",
  authDomain: "servicing-head-quarters.firebaseapp.com",
  databaseURL: "https://servicing-head-quarters-default-rtdb.firebaseio.com",
  projectId: "servicing-head-quarters",
  storageBucket: "servicing-head-quarters.firebasestorage.app",
  messagingSenderId: "464392492676",
  appId: "1:464392492676:web:32baa45d4d747b92e6d4d1"
};

const app = initializeApp(firebaseConfig);

const db = getFirestore(app);
const auth = getAuth(app);
const analytics = getAnalytics(app);
const storage = getStorage(app);

const messaging = getMessaging(app);

export { app, db, auth, storage, messaging };
